import { css, html, LitElement, PropertyValues } from "lit";
import {property, customElement} from 'lit/decorators.js';

@customElement('voy-fleet-sub-view-port-view-expected-arrivals')
export class VoyFleetSubViewPortViewExpectedArrivals extends LitElement {
    @property({ type: Number }) public imo?: number;

    constructor() {
        super();

    }

    static styles = css`
        :host {
            font-family: MaerskText;
            font-size: 12px;
            line-height: 16px;
            font-weight: 400;
        }
    `;

    connectedCallback() {
        super.connectedCallback();

    }

    disconnectedCallback() {
        super.disconnectedCallback();

    }

    updated(changedProperties: PropertyValues) {
        super.updated(changedProperties);

    }

    firstUpdated() {
    }


    render() {
        return html`Work in progress
        `;
    }
}
